import apiClient from './apiService';

export const ATTACHMENT_UPLOAD_TIMEOUT = 180000;

export function attachmentUploadError(error) {
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return 'Upload timed out. The server may still be saving the file. Refresh the attachment list before retrying.';
  }
  if (error?.response?.status === 413) return 'File or batch is too large. Limit: 100 MB per file, 200 MB per batch.';
  if (error?.response?.status === 401) return 'Your session has expired. Sign in again before uploading.';
  if (error?.request && !error?.response) {
    return 'Connection interrupted. Upload status is unknown. Refresh the attachment list before retrying.';
  }
  return error?.message || 'Upload failed. Please try again or contact support.';
}

// Keep the existing Axios response contract, but never accept HTTP 200 alone as success.
export async function postAttachment(endpoint, formData, { batch = false, ...config } = {}) {
  const response = await apiClient.post(endpoint, formData, {
    ...config,
    timeout: ATTACHMENT_UPLOAD_TIMEOUT,
  });
  const body = response?.data;
  if (Number(body?.code) !== 200) {
    throw new Error(body?.message || 'The server could not save the attachment.');
  }
  const attachments = batch ? body.data : [body.data];
  if (!Array.isArray(attachments) || attachments.length === 0 || attachments.some(
    item => item?.id == null || !String(item?.ossUrl || '').trim()
  )) {
    throw new Error('The server did not confirm that the file was saved. Refresh the attachment list before retrying.');
  }
  return response;
}
